import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=412f59d7&scoped=true&"
import script from "./reset_password.vue?vue&type=script&lang=js&"
export * from "./reset_password.vue?vue&type=script&lang=js&"
import style0 from "./reset_password.vue?vue&type=style&index=0&id=412f59d7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412f59d7",
  null
  
)

export default component.exports